import { app } from '../initApp';
import { UseCase } from './usecase/UseCase';

interface SetInitialCoachUseCaseOptions {
  sessionData: any;
}

export const setInitialCoachUseCase: UseCase = {
  type: 'SET_INITIAL_Coach',

  run: ( options: SetInitialCoachUseCaseOptions ) => {
    return Cx.resolve(options.sessionData);
  }
};

/**
 * @category Can
 */
export function canSetInitialCoach( state ) {
  return setInitialCoachUseCase.checkConditions( state ).isAllowed;
}

/**
 * @category Use Case
 */
export function setInitialCoach( options: SetInitialCoachUseCaseOptions ) {
  app.runUseCase( setInitialCoachUseCase, options );
}
